// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const FooterWrapper = styled.div<{ isDark?: boolean }>(
  ({ theme, isDark }) => css`
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    color: ${isDark ? 'red' : theme.colors.base.dark};
    border-top: 1px solid
      ${isDark ? theme.colors.gray['dark-24'] : theme.colors.gray.light};
    background-color: ${
      isDark ? theme.colors.base['light-dark-mode'] : theme.colors.gray.lighter
    };
    padding: 20px 32px;
  `,
);

export const Divider = styled.div(
  ({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.gray.light};
  `,
);

export const BeautyButton = styled.button(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    color: ${theme.colors.base.lighter};

    :hover {
      color: ${theme.colors.primary.main};
    }
  `,
);
